if (!customElements.get('vbb-reactive-price')) {
  customElements.define('vbb-reactive-price', class ReactivePrice extends HTMLElement {
    constructor() {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.victoriasRecommendation = null;
    }

    handleVariantChange() {
      var price = +(this.productForm.activeVariant.priceRaw) * 100;

      var victoriasRecommendationVariantIdEl = this.productForm.querySelector('[data-victorias-recommendation-variant-id]');

      var victoriasRecommendationVariantPrice = +(victoriasRecommendationVariantIdEl?.dataset.variantPrice);

      if (victoriasRecommendationVariantIdEl) {
        price += victoriasRecommendationVariantPrice;
      }

      this.innerText = this.formatMoney(price);
    }

    priceOveride(price, discountedPrice) {
      console.log('priceOveride', price, discountedPrice);
      if (price && discountedPrice) {
        this.innerHTML = `<s class="yotpo-strikethrough">${discountedPrice}</s> ${price}`;
      }
      else if (discountedPrice) {
        this.innerHTML = discountedPrice;
      }
    }

    connectedCallback() {
      if (!this.productForm) {
        this.productForm = this.closest('vbb-product-form-reactive');
        this.productForm.addEventListener('variant:changed', this.handleVariantChange);
        this.productForm.addEventListener('victorias-recommendation:changed', this.handleVariantChange);
      }
    }

    disconnectedCallback() {
      if (this.productForm) {
        this.productForm.removeEventListener('variant:changed', this.handleVariantChange);
        this.productForm.removeEventListener('victorias-recommendation:changed', this.handleVariantChange);
      }
    }

    formatMoney(cents, format) {
      const moneyFormat = window.moneyFormat;

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
      ) {
        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  });
}
